module.exports = __webpack_public_path__ + "img/5-r.fd6fb8e7.png";